// We use custom headers as the defaults of the application point directly to
// our backend instance
//
// Hosts are defined for each request as they differ from bank to bank

import api, { requestApi } from '@/api'
import humps from 'humps'

export default {
  fetchWebauthCode (token) {
    const biApi = requestApi(process.env.BIAPI_HOST)

    return biApi({
      method: 'GET',
      url: '/2.0/auth/token/code',
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  fetchBIToken () {
    return api.get('/users/me/connection')
  },

  confirmBIToken (data) {
    return api.post('/users/me/connection', data)
  },

  fetchBITermsStatus (token, host) {
    const biApi = requestApi(host)

    return biApi({
      method: 'GET',
      url: '/2.0/users/me/terms',
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  fetchBITerms (token, host) {
    const biApi = requestApi(host)

    return biApi({
      method: 'GET',
      url: '/2.0/terms',
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  acceptBITerms (token, host, termsId) {
    const biApi = requestApi(host)

    return biApi({
      method: 'POST',
      url: '/2.0/users/me/terms',
      headers: { Authorization: `Bearer ${token}` },
      params: { id_terms: termsId }
    })
  },

  getBIConnection (token, idConnection) {
    const biApi = requestApi(process.env.BIAPI_HOST)

    return biApi({
      method: 'GET',
      url: `/2.0/users/me/connections/${idConnection}`,
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  fetchBIUser (data) {
    const host = data.provider ? data.provider.host : process.env.BIAPI_HOST
    const biApi = requestApi(host)

    const url = data.idConnection
      ? `/2.0/users/me/connections/${data.idConnection}`
      : `/2.0/users/me/connections`

    let payload = { ...data.payload }
    if (!data.idConnection) {
      payload.idBank = data.provider.bankId
    }
    payload = humps.decamelizeKeys(payload)

    return biApi({
      method: 'POST',
      url: url,
      data: payload,
      headers: { Authorization: `Bearer ${data.token}` }
    })
  },

  fetchBIContractList (token, host, id) {
    const biApi = requestApi(host)

    return biApi({
      method: 'GET',
      url: `/2.0/users/me/connections/${id}/accounts?all`,
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  fetchBIAllContractList (token, host) {
    const biApi = requestApi(host)

    return biApi({
      method: 'GET',
      url: `/2.0/users/me/accounts?all`,
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  activateBIContract (token, host, id) {
    const biApi = requestApi(host)

    return biApi({
      method: 'PUT',
      url: `/2.0/users/me/accounts/${id}?all`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        disabled: null
      }
    })
  },

  deactivateBIContract (token, host, id) {
    const biApi = requestApi(host)

    return biApi({
      method: 'DELETE',
      url: `/2.0/users/me/accounts/${id}?all`,
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  updateBIAccountPassword (data) {
    const biApi = requestApi(data.host)

    return biApi({
      method: 'POST',
      url: `/2.0/users/me/connections/${data.id}`,
      headers: { Authorization: `Bearer ${data.token}` },
      data: data.payload
    })
  },

  deleteBIAccount (id) {
    return api.delete(`/accounts/${id}`)
  }
}
